module.exports = __webpack_public_path__ + "app/img/icon-person.4b209d9a.jpg";